import React from 'react'
import {UserContextProvider} from '../../context/User'
import {AuditContextProvider} from '../../context/Audits'
import {AuditModalApiContextProvider} from '../../context/AuditModalApi'
import {AuditPaneContextProvider} from '../../context/AuditPane'
import {TemplatesContextProvider} from '../../context/Templates'
import {AuditDetailsContextProvider} from '../../context/Modal/AuditDetails'
import {ToastMessageContextProvider} from '../../context/ToastMessage'
import {RecurringDetailsContextProvider} from '../../context/Modal/RecurringDetails'
import {GroupDetailsContextProvider} from '../../context/Modal/GroupDetails'
import {AssignAuditContextProvider} from '../../context/Modal/AssignAudit'
import {AuditDescriptionContextProvider} from '../../context/AuditDescription'
import {AuditModalBarContextProvider} from '../../context/AuditModalBar'
import {EditAuditContextProvider} from '../../context/Modal/EditAudits'
import SessionCookies from '../../modules/common/utils/sessionCookies'

function AuditInitialize({children}) {
  return (
    <SessionCookies>
      <UserContextProvider>
        <ToastMessageContextProvider>
          <AuditPaneContextProvider>
            <AuditDetailsContextProvider>
              <RecurringDetailsContextProvider>
                <GroupDetailsContextProvider>
                  <AssignAuditContextProvider>
                    <EditAuditContextProvider>
                      <AuditModalBarContextProvider>
                        <AuditModalApiContextProvider>
                          <AuditContextProvider>
                            <AuditDescriptionContextProvider>
                              <TemplatesContextProvider>{children}</TemplatesContextProvider>
                            </AuditDescriptionContextProvider>
                          </AuditContextProvider>
                        </AuditModalApiContextProvider>
                      </AuditModalBarContextProvider>
                    </EditAuditContextProvider>
                  </AssignAuditContextProvider>
                </GroupDetailsContextProvider>
              </RecurringDetailsContextProvider>
            </AuditDetailsContextProvider>
          </AuditPaneContextProvider>
        </ToastMessageContextProvider>
      </UserContextProvider>
    </SessionCookies>
  )
}

export default AuditInitialize
